import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PlaceIntravenousCatheterAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-place-intravenous-catheter-slot',
    templateUrl: './place-intravenous-catheter-slot.component.html',
    styleUrl: './place-intravenous-catheter-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaceIntravenousCatheterSlotComponent implements SheetSlotComponentBase {

	@Input() action!: PlaceIntravenousCatheterAction;
	value = null;

	constructor() {
	}
}
